module.exports = __webpack_public_path__ + "static/logo_vlm_black-e9da7bae9701beb0d81beed0f0db0650.png";